// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2c53x","info":"Note_info__1PmLM","note":"Note_note__33omq","actions":"Note_actions__2D8PI"};